// extracted by mini-css-extract-plugin
export default {"container":"thumbnail-loading-indicator_container__SXn07"};